<div
    class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-flex-100 cmps-cdk-cg-0dot5"
>
    <div class="cmps-cdk-font-size-15p cmps-cdk-font-bold">
        {{ _i18n._11194_CONNECTION_SCORE | translate }}
    </div>
    <div
        class="cmps-cdk-bg-color-unknown-117 cmps-cdk-border-radius-12px cmps-cdk-color-unknown-125 cmps-cdk-px-0dot5 cmps-cdk-white-space-nowrap"
    >
        {{ _i18n._11195___ALIGNMENT | translate }}
    </div>
    <div
        class="cmps-cdk-h-10px cmps-cdk-border-radius-6p cmps-cdk-bg-color-grey-300 cmps-cdk-flex-grow-1 cmps-cdk-overflow-hidden"
    >
        <div
            class="cmps-cdk-border-radius-6p cmps-cdk-bg-gradient-green-100-0 cmps-cdk-h-100p"
            [style.width.%]="(scorePercent ?? 0) * 100"
        ></div>
    </div>
    <div class="cmps-cdk-font-size-18p cmps-cdk-font-bold">
        {{ scorePercent ?? 0 | cmpsPercent: '1.0-0' }}
    </div>
    <div>
        <cmps-icon
            class="cmps-cdk-fill-grey-400"
            svgIcon="information"
            [cmpsOverlayTrigger]="legendTpl"
            placement="bottom-right"
        ></cmps-icon>
    </div>
</div>

<ng-template #legendTpl>
    <cmps-ca-score-section-legend></cmps-ca-score-section-legend>
</ng-template>
